<div class="modal-confirm-logout">
  <h1>Apa Kamu yakin Ingin Keluar dari Akun {{ storage.profile?.fullname }} ?</h1>
  <p>
    Tidak Login atau tidak ada aktifitas pada akun kemitraanmu dalam jangka waktu tertentu akan menyebabkan 
    <strong>akun kemitraanmu terkena Suspend</strong>,
    jadi jangan lupa untuk login lagi ya~
  </p>
  <ion-button expand="block" color="bg-brand-bold" (click)="modal?.dismiss()">Tidak Jadi Keluar</ion-button>
  <ion-button expand="block" color="bg-brand-subtler" (click)="logout()">Konfirmasi Keluar</ion-button>
</div>